<script setup>
    import { ShoppingBagIcon } from '@heroicons/vue/24/outline'
</script>

<template>
    <ShoppingBagIcon />
</template>
